import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const FacebookIcon: FunctionComponent<IconProps> = ({ size = 24, testID }) => (
  <svg
    width={size}
    height={size}
    data-testid={testID}
    fill="none"
    stroke="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.25 0C4.727 0 0.25 4.477 0.25 10C0.25 15.013 3.943 19.153 8.755 19.876V12.65H6.281V10.021H8.755V8.272C8.755 5.376 10.166 4.105 12.573 4.105C13.726 4.105 14.335 4.19 14.624 4.229V6.523H12.982C11.96 6.523 11.603 7.492 11.603 8.584V10.021H14.598L14.192 12.65H11.604V19.897C16.485 19.236 20.25 15.062 20.25 10C20.25 4.477 15.773 0 10.25 0Z"
      fill="#3776EA"
    />
  </svg>
);

export { FacebookIcon };
